module.exports = __webpack_public_path__ + "img/9ae7d80bd66656cfbf1e0dba7745bd37.png";